export async function requestNotificationsPermission() {
  try {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log('[Browser notifications] Permission granted');
    }
  } catch (e) {
    console.error(e);
  }
}

export function launchNotification({
  title = '',
  options = {},
  handleClick = () => {
    /*noop*/
  },
}) {
  try {
    if (Notification.permission === 'granted') {
      const notification = new Notification(title, options);

      const closeNotification = () => {
        if (!!notification?.close) notification.close();
      };

      notification.onclick = () => {
        handleClick();
        closeNotification();
      };
      notification.onshow = () => {
        setTimeout(() => {
          closeNotification();
        }, 10000);
      };

      return notification;
    }
  } catch (e) {
    console.error(e);
  }
}
